import { createFileRoute } from '@tanstack/react-router';
import EmailVerifiedPage from '@/components/EmailVerifiedPage';

export const Route = createFileRoute('/verified')({
  component: EmailVerifiedPage,
});
